// cSpell:enableCompoundWords
import EditableField from 'components/editablefield/EditableField';
import IconButton from 'components/iconbutton/IconButton';
import LabeledField from 'components/labeledfield/LabeledField';
import Ruler from 'components/ruler/Ruler';
import MatchItem from 'components/tabs/gameselect/components/matchitem/MatchItem';
import { ActionCls, Emojis, RulerType, ValueCls } from 'constants/constants';
import { useAppSelector } from 'hooks/hooks';
import useLobbyManager from 'hooks/useLobbyManager';
import React, { useCallback, useEffect, useState } from 'react';
import { isMatchesLoaded, isTeamsLoaded } from 'slices/SqScheduleSlice';
import { ASComponentSize, Maybe } from 'types/App.types';
import { ScheduledMatch } from 'types/Schedule.types';
import styles from './GamesSection.module.scss';

type CompletedGamesSectionProps = {
  className?: string;
};

const CreateGameSection: React.FC<CompletedGamesSectionProps> = ({ className = '' }) => {
  const baseCls = `${styles.SectionList} ${styles.SectionListRow} ${styles.JustifyCenter} ${className}`;

  const [createGameName, setCreateGameName] = useState('');
  const [matchId, setMatchId] = useState('');

  const inputWidth = { width: '230px' };

  const teamsLoaded = useAppSelector(isTeamsLoaded);
  const matchesLoaded = useAppSelector(isMatchesLoaded);

  const { matches, onCreateGame, loadTeamsAndMatches, playerName } = useLobbyManager();

  const onMatchSelected = useCallback((matchId: string, match: Maybe<ScheduledMatch>) => {
    console.log(`${Emojis.eyes} %c MATCH SELECTED %c %c ${matchId} %c`, ActionCls, '', ValueCls, '');
    setMatchId(matchId);
    if (match && match.startingDate) {
      setMatchId(match.matchId);
      const dt = new Date(match.startingDate).toISOString();
      const prefix = dt.slice(5, 10);
      const teams = `${match.homeTeamAbv}-${match.awayTeamAbv}`;
      setCreateGameName(`${prefix}-${teams}-${playerName.slice(0, 5)}`);
    }
  }, [playerName]);

  useEffect(() => {
    if (!teamsLoaded || !matchesLoaded) loadTeamsAndMatches();
  }, [teamsLoaded, matchesLoaded, loadTeamsAndMatches]);

  const isComplete = createGameName.length > 0 && matchId.length > 0;

  // set first game in `matches` as default selected game on load
  if (matches && matches.length > 0 && !matchId) {
    const match = matches[0];
    setMatchId(match.matchId);
    if (match.startingDate) {
      const dt = new Date(match.startingDate).toISOString();
      const prefix = dt.slice(5, 10);
      const teams = `${match.homeTeamAbv}-${match.awayTeamAbv}`;
      setCreateGameName(`${prefix}-${teams}-${playerName.slice(0, 5)}`);
    }
  }


  const onCreateGameNameEnter = (name: string) => {
    setCreateGameName(name);
  };

  const onEnter = () => {
    if (createGameName && matchId) {
      onCreateGame(createGameName, matchId);
    }
  };




  return (
    <>
      {matches.length > 0 && (
        <div className={baseCls}>
          {matches.map((match) => {
            return (
              <MatchItem
                key={match.matchId}
                match={match}
                selected={match.matchId === matchId}
                onMatchClicked={onMatchSelected}
              />
            );
          })}
        </div>
      )}

      <Ruler className={RulerType.MODAL_SEPARATOR_THIN} style={{ marginBottom: '0' }} />
      <LabeledField labelSize={40} style={{ justifyContent: 'center' }} fieldLabel="GAME NAME">
        <EditableField
          fieldValue={createGameName}
          name="Game Name"
          preventExitEditModeWhenEmptyString
          minLength={2}
          maxLength={15}
          editingMode
          onFieldChange={onCreateGameNameEnter}
          aria-label="Input field for the game title that user is creating"
          style={inputWidth}
        />
      </LabeledField>

      {isComplete && (
        <IconButton size={ASComponentSize.Large} onClick={onEnter}>
          {Emojis.football}
        </IconButton>
      )}
    </>
  );
};

export default CreateGameSection;
